export function sprintf(format: string, ...args: string[]) {
    for (let argument of args) {
        format = format.replace(/%s/, argument);
    }
    return format;
}